import TablePage from '../../../../../components/table_page';
import Form from './form/index';

export default {
  name: 'banquet_recommender',
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {};
  },
  created() {
    this.getConfigList('banquet_recommender');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'view') {
        this.formName = 'Form';
        this.modalConfig.title = '详情';
        this.formConfig = {
          code: val.code,
          row,
        };
        this.openFull();
      }
    },
  },

};
